export default "__VITE_ASSET__BcGUpDDt__"